var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clrm-body"},[_c('div',{staticClass:"clrm-container-fluid"},[_c('Classroom',{ref:"Classroom",attrs:{"classroomInfo":_vm.classroomInfo,"zoom":_vm.zoom}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }